import type { InsumoMaestro } from '../presupuestos/tipos'

export const INSUMOS_INICIALES: InsumoMaestro[] = [
  // ── Materiales ─────────────────────────────────────────────────────────────
  {
    id: 'ins-mat-01',
    codigo: 'MAT-VAR-58',
    nombre: 'Varilla Cooperweld 5/8 pulgada x 2.40 m',
    tipo: 'material',
    unidad: 'UND',
    tarifa_base: 312147.83,
    categoria: 'Puesta a Tierra',
    activo: true,
  },
  {
    id: 'ins-mat-02',
    codigo: 'MAT-SOL-115',
    nombre: 'Soldadura exotérmica cartucho 115 g',
    tipo: 'material',
    unidad: 'UND',
    tarifa_base: 30608.7,
    categoria: 'Puesta a Tierra',
    activo: true,
  },
  {
    id: 'ins-mat-03',
    codigo: 'MAT-TUB-IMC',
    nombre: 'Tubo metálico IMC 1/2 pulgada x 3 m',
    tipo: 'material',
    unidad: 'UND',
    tarifa_base: 17391.3,
    categoria: 'Canalizaciones',
    activo: true,
  },
  {
    id: 'ins-mat-04',
    codigo: 'MAT-CAB-8V',
    nombre: 'Cable Cu aislado No 8 AWG verde 7 hilos',
    tipo: 'material',
    unidad: 'M',
    tarifa_base: 7652.17,
    categoria: 'Conductores',
    activo: true,
  },
  {
    id: 'ins-mat-05',
    codigo: 'MAT-CAB-20',
    nombre: 'Cable de cobre desnudo 2/0 AWG 7 hilos',
    tipo: 'material',
    unidad: 'M',
    tarifa_base: 51428.94,
    categoria: 'Conductores',
    activo: true,
  },
  {
    id: 'ins-mat-06',
    codigo: 'MAT-TUB-EMT-34',
    nombre: 'Tubería conduit metálica EMT 3/4 pulgada x 3 m',
    tipo: 'material',
    unidad: 'UND',
    tarifa_base: 24800.0,
    categoria: 'Canalizaciones',
    activo: true,
  },
  {
    id: 'ins-mat-07',
    codigo: 'MAT-LUM-28W',
    nombre: 'Luminaria vial LED 27.8W 5000K IP66 IK08',
    tipo: 'material',
    unidad: 'UND',
    tarifa_base: 243478.26,
    categoria: 'Alumbrado Público',
    activo: true,
  },
  {
    id: 'ins-mat-08',
    codigo: 'MAT-FOT-7P',
    nombre: 'Fotocontrol electrónico 7 pines 105-305V',
    tipo: 'material',
    unidad: 'UND',
    tarifa_base: 39130.43,
    categoria: 'Alumbrado Público',
    activo: true,
  },
  {
    id: 'ins-mat-09',
    codigo: 'MAT-BRA-15',
    nombre: 'Brazo metálico galvanizado en caliente 1.5 m',
    tipo: 'material',
    unidad: 'UND',
    tarifa_base: 47826.09,
    categoria: 'Alumbrado Público',
    activo: true,
  },
  {
    id: 'ins-mat-10',
    codigo: 'MAT-BOR-20',
    nombre: 'Bornera estañada de cobre para cable 2/0 AWG',
    tipo: 'material',
    unidad: 'UND',
    tarifa_base: 8542.43,
    categoria: 'Accesorios',
    activo: true,
  },

  // ── Mano de Obra (Tarifas Día) ─────────────────────────────────────────────
  {
    id: 'ins-mo-01',
    codigo: 'MO-OFI-CIV',
    nombre: 'Oficial de Obra Civil',
    tipo: 'mano_obra',
    unidad: 'DIA',
    tarifa_base: 184558.4,
    categoria: 'Personal de Obra',
    activo: true,
  },
  {
    id: 'ins-mo-02',
    codigo: 'MO-TEC-ELE',
    nombre: 'Técnico Electricista Certificado CONTE',
    tipo: 'mano_obra',
    unidad: 'DIA',
    tarifa_base: 184558.4,
    categoria: 'Personal Eléctrico',
    activo: true,
  },
  {
    id: 'ins-mo-03',
    codigo: 'MO-AYU-ELE',
    nombre: 'Ayudante de Electricidad',
    tipo: 'mano_obra',
    unidad: 'DIA',
    tarifa_base: 116532.0,
    categoria: 'Personal Eléctrico',
    activo: true,
  },
  {
    id: 'ins-mo-04',
    codigo: 'MO-LIN-RED',
    nombre: 'Técnico Liniero Redes de Distribución',
    tipo: 'mano_obra',
    unidad: 'DIA',
    tarifa_base: 195000.0,
    categoria: 'Redes y Alturas',
    activo: true,
  },

  // ── Equipos y Herramientas ─────────────────────────────────────────────────
  {
    id: 'ins-eq-01',
    codigo: 'EQ-HER-MEN',
    nombre: 'Caja de herramientas menores cuadrilla',
    tipo: 'equipo',
    unidad: 'EQU',
    tarifa_base: 16693.75,
    categoria: 'Herramientas',
    activo: true,
  },
  {
    id: 'ins-eq-02',
    codigo: 'EQ-GRU-CAN',
    nombre: 'Grúa con canasta aislada para trabajos en altura',
    tipo: 'equipo',
    unidad: 'HORA',
    tarifa_base: 150000.0,
    categoria: 'Maquinaria y Equipos',
    activo: true,
  },
  {
    id: 'ins-eq-03',
    codigo: 'EQ-TEL-MED',
    nombre: 'Telurómetro digital calibrado medición tierras',
    tipo: 'equipo',
    unidad: 'DIA',
    tarifa_base: 45000.0,
    categoria: 'Equipos de Medida',
    activo: true,
  },

  // ── Transportes ────────────────────────────────────────────────────────────
  {
    id: 'ins-tr-01',
    codigo: 'TR-CAM-4X4',
    nombre: 'Camioneta 4x4 cuadrilla y acarreos',
    tipo: 'transporte',
    unidad: 'VIAJE',
    tarifa_base: 130500.0,
    categoria: 'Transporte Terrestre',
    activo: true,
  },
  {
    id: 'ins-tr-02',
    codigo: 'TR-FLE-MAT',
    nombre: 'Flete y transporte de materiales en camión',
    tipo: 'transporte',
    unidad: 'VIAJE',
    tarifa_base: 85000.0,
    categoria: 'Transporte Terrestre',
    activo: true,
  },
]

